module.exports = __webpack_public_path__ + "img/3.ff038c41.webp";